import * as React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import InformationLogo from "media/images/shora.png"
import { useInView } from "react-intersection-observer"
import "./footer.scss"

const Telegram = "/assets/svg/telegram.svg"
const Instagram = "/assets/svg/instagram.svg"
const Twitter = "/assets/svg/twitter.svg"

const Discount = "/assets/svg/discount.svg"
const DeliveryTruck = "/assets/svg/delivery-truck.svg"
const Guarantee = "/assets/svg/guarantee.svg"

const howTo = [
	{
		key: "f101",
		text: "راهنمای خرید از  وب سایت",
		to: "/help",
	},
	{
		key: "f102",
		text: "مرجع پرسش‌های متداول",
		to: "/faq",
	},
]

const blog = [
	{
		key: "f201",
		text: "آنتی ویروس چیست ؟",
		to:
			"/post/%D9%88%DB%8C%D8%B1%D9%88%D8%B3-%DA%A9%D8%A7%D9%85%D9%BE%DB%8C%D9%88%D8%AA%D8%B1%DB%8C-%DA%86%DB%8C%D8%B3%D8%AA-%D8%A2%D9%86%D8%AA%DB%8C-%D9%88%DB%8C%D8%B1%D9%88%D8%B3-%DB%8C%D8%A7-%D8%B6%D8%AF-%D9%88%DB%8C%D8%B1%D9%88%D8%B3-%DA%86%DB%8C%D8%B3%D8%AA",
	},
	{
		key: "f202",
		text: "آنتی ویروس مالتی دیوایس چیست ؟",
		to:
			"/post/%D8%A2%D9%86%D8%AA%DB%8C-%D9%88%DB%8C%D8%B1%D9%88%D8%B3-%D9%85%D8%A7%D9%84%D8%AA%DB%8C-%D8%AF%DB%8C%D9%88%D8%A7%DB%8C%D8%B3-%DA%86%DB%8C%D8%B3%D8%AA",
	},
]

const support = [
	{
		key: "f401",
		text: "پشتیبانی تلگرامی: @antivirus_support",
		to: "https://telegram.me/antivirus_support",
	},
	{
		key: "f403",
		text: "پشتیبانی تلفنی: 88932445",
		to: "tel:+982188932445",
	},
]

const popup = (location: string) => {
	window.open(
		location,
		"Popup",
		"toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
	)
}

interface Namad
	extends React.DetailedHTMLProps<
		React.ImgHTMLAttributes<HTMLImageElement>,
		HTMLImageElement
	> {
	target: string
}

const Namad: React.FC<Namad> = ({ target, alt, src, ...rest }) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	return (
		<button
			ref={ref}
			className="footer__namadbtn"
			onClick={() => popup(target)}
		>
			<img
				width="150"
				height="150"
				src={inView ? src : ""}
				alt={alt}
				{...rest}
			/>
		</button>
	)
}

const Footer: React.FC = () => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	return (
		<>
			<Container className="align-center text-center">
				<Row className="footer__features d-flex flex-column flex-md-row justify-content-around align-items-center">
					<div className="pb-4">
						<img
							ref={ref}
							src={inView ? Guarantee : ""}
							alt="ضمانت اصالت کالا"
							width="70"
							height="104"
						/>
						<p>ضمانت اصالت کالا</p>
					</div>
					<div className="pb-4">
						<img
							src={inView ? Discount : ""}
							alt="قیمت مناسب"
							width="97"
							height="97"
						/>
						<p>قیمت مناسب</p>
					</div>
					<div className="pb-4">
						<img
							src={inView ? DeliveryTruck : ""}
							alt="تحویل آنی لایسنس"
							width="97"
							height="86"
						/>
						<p>تحویل آنی لایسنس</p>
					</div>
				</Row>
				<Row>
					<Col lg="12">
						<p className="footer__text">
							مرجع آنتی ویروس ایران متعلق به شرکت فناوری اطلاعات
							نیماک (سهامی خاص) به شمار ثبت ۲۳۲۷۴۹ و تاسیس ۱۳۸۳
							می‌باشد. مرجع آنتی ویروس ایران با معرفی و عرضه
							محصولات امنیتی معتبر موجود در بازار ایران و امکان
							خرید آگاهانه و هزینه مناسب را برای شما فراهم نموده
							است. این مرجع ارائه کننده انواع نرم افزارهای تخصصی
							مقابله با تهدیدات سایبری نظیر ویروس‌ها و بدافزارها
							برای انواع کامپیوترها، تبلت‌ها و موبایل‌ها می‌باشد.
							این مرجع با اطلاع رسانی اخبار مهم و فعالیت‌های جدید
							صورت گرفته در این حوزه به کاربران کمک می‌کند تا با
							امنیت بیشتری از دستگاه خود استفاده نمایند. بررسی
							تخصصی آنتی ویرس‌های موجود در بازار که توسط این مرجع
							صورت می‌گیرد به خریداران کمک می‌کند تا با آگاهی از
							نقاط قوت و ضعف آنها بهترین انتخاب را داشته باشند.
						</p>
					</Col>
				</Row>
				<Row className="d-flex flex-column flex-md-row justify-content-around align-items-center footer__namad">
					<a
						// eslint-disable-next-line react/jsx-no-target-blank
						target="_blank"
						href="https://trustseal.enamad.ir/?id=735&amp;Code=iKwE0hTt4dRLZfT8QDHC"
					>
						<img
							className="cursor-pointer"
							src="https://Trustseal.eNamad.ir/logo.aspx?id=735&amp;Code=iKwE0hTt4dRLZfT8QDHC"
							alt=""
							id="iKwE0hTt4dRLZfT8QDHC"
						/>
					</a>
					<Namad
						id="jxlzfukzwlaooeukjxlz"
						alt="logo-samandehi"
						src="https://logo.samandehi.ir/logo.aspx?id=16481&p=nbpdwlbqshwlaqgwnbpd"
						target="https://logo.samandehi.ir/Verify.aspx?id=16481&p=rfthgvkaaodsmcsirfth"
					/>
					<Namad
						id="shora"
						alt="logo-informatic"
						src={InformationLogo}
						target="https://sajar.mporg.ir/Company/CompanyDetail?cp=74876&cr=59756&crt=32"
					/>
				</Row>
			</Container>
			<footer className="footer">
				<Container>
					<Row>
						<Col lg="3">
							<List title="راهنمای استفاده از وبسایت">
								{howTo.map((item) => (
									<li key={item.key}>
										<Link
											to={item.to}
											className="footer__item"
										>
											{item.text}
										</Link>
									</li>
								))}
							</List>
						</Col>
						<Col lg="3">
							<List title="در وبلاگ آنتی ویروس بخوانید">
								{blog.map((item) => (
									<li key={item.key}>
										<Link
											to={item.to}
											className="footer__item"
										>
											{item.text}
										</Link>
									</li>
								))}
							</List>
						</Col>
						<Col lg="3">
							<Title>آنتی ویروس در شبکه‌های اجتماعی</Title>
							<div className="footer__icon mb-3">
								<a href="https://t.me/antivirusir">
									<img
										src={inView ? Telegram : ""}
										alt="تلگرام"
										className="fit"
										width="30"
										height="27"
									/>
								</a>
								<a
									href="https://twitter.com/antivirus_ir"
									className="footer__icon--center"
								>
									<img
										src={inView ? Twitter : ""}
										alt="توییتر"
										className="fit"
										width="30"
										height="27"
									/>
								</a>
								<a href="https://instagram.com/antivirus.ir">
									<img
										src={inView ? Instagram : ""}
										alt="اینستاگرام"
										className="fit"
										width="27"
										height="27"
									/>
								</a>
							</div>
						</Col>
						<Col lg="3">
							<List title="تماس با تیم پشتیبانی">
								{support.map((item) => (
									<li key={item.key}>
										<a
											href={item.to}
											className="footer__item"
										>
											{item.text}
										</a>
									</li>
								))}
							</List>
						</Col>
					</Row>
					<ul className="footer__links">
						<li>
							<Link to="/about-us">درباره ما</Link>
						</li>
						<li>
							<Link to="/contact-us">تماس با ما</Link>
						</li>
						<li>
							<Link to="/terms-conditions">شرایط استفاده</Link>
						</li>
					</ul>
				</Container>
			</footer>
		</>
	)
}

const Title: React.FC<{}> = ({ children }) => {
	return <h4 className="footer__title">{children}</h4>
}

const List: React.FC<{ title: string }> = ({ title, children }) => {
	return (
		<>
			<Title>{title}</Title>
			<ul className="footer__list">{children}</ul>
		</>
	)
}

export default Footer
